export default __webpack_public_path__ + "img/istockphoto_1.0001772f.jpeg";